import { apiClient } from "../config";

async function getAllLayersList(queryParams: any) {
  const res = await apiClient.get(`/admin/geographies`, {
    params: queryParams,
  });
  return res.data;
}

export default getAllLayersList;
